import { LuFileDown } from "react-icons/lu";
import { IoCloseOutline } from "react-icons/io5";
import { RiErrorWarningFill } from "react-icons/ri";
import ThreeDotsLoading from "./ThreeDotsLoading";
import { url } from "./firebase";

const MSG_TYPE_ENUM = {
    LOADING: 0,
    TEXT_VISITOR: 1,
    TEXT_CLIENT: -1,
    FILE_VISITOR: 2,
    FILE_CLIENT: -2,
    AUTO_REPLY_VISITOR: 3,
    AUTO_REPLY_CLIENT: -3,
    AUTO_SOLICIT: -4,
    AUTO_SOLICIT_SAVED: -5,
    AUTO_SOLICIT_INFO: -6,
    AUTO_ENGAGE: -7,
    AUTO_SOLICIT_CLOSED: -8,
    WELCOME_MSG: -9,
    EMAIL_VISITOR: 4,
    ERROR: -10,
    DISABLED: -11,
}

export default function Message({ message, msgType, slack_ts, handleSolicitSaved, fileUrl, fileName, handleSolicitClosed, discord_ts }) {
  
    const messageClass = msgType < 0 ? 'client' : 'visitor';

    if (msgType === MSG_TYPE_ENUM.ERROR) {
        return <ErrorMessage message={message} messageClass={messageClass} />
    }

    if (msgType === MSG_TYPE_ENUM.DISABLED) {
        return <DisabledMessage message={message} messageClass={messageClass} />
    }

    if (msgType === MSG_TYPE_ENUM.LOADING) {
        return <LoadingMessage messageClass={messageClass} />
    }
    
    if (msgType === MSG_TYPE_ENUM.AUTO_SOLICIT_INFO || msgType === MSG_TYPE_ENUM.AUTO_SOLICIT_CLOSED || msgType === MSG_TYPE_ENUM.EMAIL_VISITOR) {
        return; // gonna need to cleanup confliction of remote and local auto solicit saved, info is saved but just for remote update
    }

    if (msgType === MSG_TYPE_ENUM.AUTO_SOLICIT) {
        return <AutoSolicit message={message} messageClass={messageClass} handleSolicitSaved={handleSolicitSaved} handleSolicitClosed={handleSolicitClosed} />;
    }

    if (fileUrl) {//(msgType === MSG_TYPE_ENUM.FILE_CLIENT || msgType === MSG_TYPE_ENUM.FILE_VISITOR) {
        return <FileMessage fileUrl={fileUrl} messageClass={messageClass} fileName={fileName} discord_ts={discord_ts} />
    }
  
    return (
        <div className={`message message_${messageClass}`}>
            <div className='message_content'>
                <div className='text'>
                    <span>{message}</span>
                </div>
            </div>
        </div>
    )
}

function AutoSolicit({ message, messageClass, handleSolicitSaved, handleSolicitClosed }) {

    return (
        <div className={`message message_${messageClass}`}>
            <div className="message_content_solicit">
                <div className="solicit-text-close">
                    <div className="text">
                        <span>{message}</span>
                    </div>
                    <IoCloseOutline className="solicit-close" onClick={handleSolicitClosed}/>
                </div>
                <div className='solicit'>
                    <form onSubmit={handleSolicitSaved} className='solicit-form'>
                        <input type="text" name="name" placeholder="Name" className="solicit-form-input"/>
                        <input type="email" name="email" placeholder="Email" className="solicit-form-input" required />
                        <button type="submit" className='solicit-form-button'>Submit</button>
                    </form>
                </div>
            </div>
        </div>
    );
}

function FileMessage({ fileUrl, messageClass, fileName, discord_ts }) {

    if (discord_ts) {
        fileUrl = `${url}/proxy-download?url=${encodeURIComponent(fileUrl)}&fileName=${encodeURIComponent(fileName)}`;
    }

    return (
        <div className={`message message_${messageClass}`}>
            <div className='message_content'>
                <LuFileDown  className="message_file_svg"/>
                <div className='text'>             
                    <a 
                        href={fileUrl} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="file-link"
                    >
                        {fileName}
                    </a>
                </div>
            </div>
        </div>
    );
}

function ErrorMessage({ message, messageClass }) {
    return (
        <div className={`message message_${messageClass}`}>
            <div className='message_content error-message'>
                <RiErrorWarningFill className="message_file_svg" style={{ color: "#ca2727" }}/>
                <div className='text'>
                    <span>{message}</span>
                </div>
            </div>
        </div>
    );
}

function LoadingMessage({ messageClass }) {
    return (
        <div className={`message message_${messageClass}`}>
            <div className='message_content'>
                <div className='text'>
                    <span><ThreeDotsLoading /></span>
                </div>
            </div>
        </div>
    );
}

function DisabledMessage({ message, messageClass }) {
    return (
        <div className={`message message_${messageClass}`}>
            <div className='message_content'  style={{ backgroundColor: "#f5e082" }}>
                <div className='text'>
                    <span>{message}</span>
                </div>
            </div>
        </div>
    );
}

export { MSG_TYPE_ENUM };